import { z } from 'zod';
/**
 * Micro-B (owner-besluit 19/20-10): de instellingen van een firma — vandaag de
 * standaard-adviseur voor web-aanvragen (Bewertung, Vor-Ort, Besichtigung/
 * Unterlagen). `GET`/`PATCH /einstellungen/web-anfragen`.
 */
/** Wie kandidaat is: de staf-rollen die een aanvraag kunnen opnemen. */
export const WEB_ANFRAGEN_KANDIDAAT_ROLLEN = ['admin', 'advisor', 'backoffice', 'makler'];
/** `PATCH /einstellungen/web-anfragen` — STRIKT: één sleutel, uuid of `null` (= nicht zugewiesen). */
export const webAnfragenEinstellungPatchSchema = z
    .object({ zustaendigerUserId: z.string().uuid().nullable() })
    .strict();
